import './_styles.scss';
import React from 'react';
import numeral from 'numeral';
import Rating from '../Rating';
import Placeholder from './_placeholder';

const handle_click = (url) => window.location.replace(url);

export default ({ id, rating, title, image, price, category, loading }) => {

  const { score } = rating || {};

  if (!!loading) return (<Placeholder/>);

  const Image = { backgroundImage: `url(${image})` };

  return (
    <div onClick={() => handle_click(`/products/${category}/${id}`)} className='Item-Card'>

      <div className="Item-Image" style={Image}/>

      <div className="Item-Card-Content">
        <Rating score={score}/>
        <div className="Item-Description">{title}</div>
        <div className="Item-Price">KSH {numeral(price).format('0,0')}</div>
      </div>

    </div>
  )
}
